import React, { useState, useEffect } from 'react';
import OrderStatusComponent from './component/OrderStatusComponent';
import CartProductListSidebar from './component/CartProductListSidebar';
import { useSelector, useDispatch } from 'react-redux';
import { updateOrderTable, removeOrderTable } from '@/store/actions';
import { useNavigate } from 'react-router-dom';
import validationErrors from '@/lib/validationErrors';
import { useParams } from 'react-router-dom';
import { getByTableIdOrderService } from '@/services/OrderServices';
import { getFileUrl } from '@/services/CommonService';
import Moment from 'moment';

const OrderDetailsPage = () => {
    const { generalSetting } = useSelector((state) => state?.GeneralSetting);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { slug, id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [paymentType, setPaymentType] = useState(1);
    const [orderData, setOrderData] = useState();
    const paymentStatusOptionList = [
        { value: 1, label: 'Unpaid' },
        { value: 2, label: 'Paid' },
        { value: 3, label: 'Failed' },
        { value: 4, label: 'Waiting For Approval' },
    ];
    useEffect(() => {
        if (id && id != '') {
            getOrderById(id);
        }
    }, [id]);

    const getOrderById = (id) => {
        setIsLoading(true);
        dispatch(getByTableIdOrderService(id))
            .then((res) => {
                setOrderData(res?.data?.data);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <section className="pt-8 pb-16">
            <div className="container max-w-3xl">
                <div className="flex items-start flex-col md:flex-row gap-6">
                    <div className="w-full">
                        <div className="p-4 mb-6 rounded-2xl shadow-xs bg-white">
                            <h3 className="text-sm leading-6 mb-1 font-medium">
                                Order ID: <span className="text-[#008BBA]">#{orderData?.order_serial_no}</span>
                            </h3>
                            <p className="text-xs font-light mb-3">{Moment(orderData?.order_datetime).format('Y-M-D hh:mm:ss')}</p>
                            <div className="flex flex-wrap items-center gap-2 mb-1">
                                <span className="text-sm capitalize">Order Type:</span>
                                <span className="text-sm capitalize text-heading">Dining Table</span>
                            </div>
                            <div className="flex flex-wrap items-center gap-2 mb-5">
                                <span className="text-sm capitalize">Table Name:</span>
                                <span className="text-sm capitalize text-heading">{orderData?.dining_table?.name}</span>
                            </div>
                            <OrderStatusComponent orderData={orderData} />
                            <div>
                                <h3 className="font-medium mb-2">{generalSetting?.company_name}</h3>
                                <div className="flex items-center justify-between gap-5">
                                    <div className="flex items-start justify-start gap-2.5">
                                        <i className="lab lab-location text-xs leading-none mt-1.5 flex-shrink-0 lab-font-size-14"></i>
                                        <span className="text-sm leading-6 text-heading">{generalSetting?.company_address}</span>
                                    </div>
                                    <div className="flex gap-4" style={{ display: 'flex' }}>
                                        <a href={`tel:${generalSetting?.company_phone}`} className="w-8 h-8 rounded-full flex items-center justify-center bg-primary-light">
                                            <i className="lab lab-call-calling font-fill-primary lab-font-size-16"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {orderData?.reason && orderData?.reason != '' ? (
                                <div className="mt-4" style={{ display: 'block' }}>
                                    <h3 className="capitalize font-medium text-sm leading-6 mb-2">Reason:</h3>
                                    <p className="text-sm text-heading mb-2">{orderData?.reason}</p>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div style={{ display: 'block' }} className="p-4 rounded-2xl shadow-xs bg-white">
                            <h3 className="capitalize font-medium text-sm leading-6 mb-2">Payment Info</h3>
                            <ul className="flex flex-col gap-2 mb-2">
                                <li className="flex items-center gap-2">
                                    <span className="capitalize text-sm leading-6">Method:</span>
                                    <span className="capitalize text-sm leading-6 text-heading">
                                        {orderData?.payment_method_id && orderData?.payment_gateway ? orderData?.payment_gateway?.name : 'Cash'}
                                    </span>
                                </li>
                                <li className="flex items-center gap-2">
                                    <span className="capitalize text-sm leading-6">Payment Status:</span>
                                    <span className={`capitalize text-sm leading-6 ${orderData?.payment_status === 2 ? 'text-green-600' : 'text-[#FB4E4E]'}`}>
                                        {orderData?.payment_status && paymentStatusOptionList.find((da) => da.value === orderData?.payment_status).label}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="w-full">
                        <CartProductListSidebar title="Order Details" orderData={orderData} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OrderDetailsPage;
